import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useApp } from '../hooks/useApp'
import { Safety } from '../classes/Safety'

export function IndexPage(): React.ReactElement {

  const navigate = useNavigate()
  const app = useApp()

  useEffect(() => {
    const token = Safety.get('token')
    if (!token) {
      navigate('/login')
    } else {
      if (app.user?.role === 'ROOT') {
        navigate('/admin/quick-finder')
      } else if (app.user?.role === 'ADMIN') {
        navigate('/admin/user-groups')
      } else {
        navigate('/home')
      }
    }
  })

  return <></>
}
